import dayjs from 'dayjs';
import type { ConversationSessionsTypeUnion } from '@/models/conversations/conversation-session';
import { useConversationSessionStore } from '@/stores/conversation-session';
import cn from '@/utils/merge-class-names';
import { generateSessionKey } from '@/utils/session';

type Props = {
  session: ConversationSessionsTypeUnion;
};

export default function SessionListItemTime({ session }: Props) {
  const { ID, SessionType, LastMsgTimeStamp, LastMsgID, UnReadCount, IsNotDisturb } = session;
  const key = generateSessionKey(SessionType, ID);
  const lastReadId = useConversationSessionStore((s) => s.lastReadIds[key]);
  const isNewSession = LastMsgID === 0 && lastReadId === undefined;

  return (
    <div className='flex flex-col items-end justify-start gap-2'>
      <span className='whitespace-nowrap text-[0.75rem] text-secondary'>{dayjs(LastMsgTimeStamp).fromNow()}</span>

      <span
        className={cn('rounded-full text-center size-4 bg-red-500 text-[0.625rem] text-inverse', {
          hidden: !isNewSession && UnReadCount === 0,
          'w-[1.3125rem]': !IsNotDisturb && !isNewSession && UnReadCount > 99,
          'mt-1 aspect-square size-2 p-0 text-base': IsNotDisturb,
        })}>
        {IsNotDisturb ? null : isNewSession ? '1' : UnReadCount > 99 ? '99+' : UnReadCount}
      </span>
    </div>
  );
}
